class ToastMessage extends HTMLElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.events();
    }

    load = () => {
        const iptAlerts = this.querySelector("input[name=alerts]");

        if (iptAlerts) {
            let data = JSON.parse(atob(iptAlerts.value));
            let property = Object.keys(data)[0];

            if (property) {
                this.showToast(data[property], "_" + property, true);
            }
        }
    };

    events = () => {
        this.addEventListener("click", (e) => {
            const btnClose = e.target.closest("button[name=close]");

            if (btnClose) {
                this.closeToast(btnClose.parentElement);
            }
        });
    };

    showToast = (
        message,
        type = "_success",
        autoClose = true,
        duration = 7000
    ) => {
        const container = this;

        const toast = document.createElement("div");
        toast.classList.add("_toast", type);

        toast.innerHTML = ` <span>${message}</span> <button type="button" class="_close_btn" name="close">&times;</button>`;

        if (autoClose) {
            const progress = document.createElement("div");
            progress.classList.add("_toast_progress");
            progress.style.setProperty("--toast-duration", `${duration}ms`);
            toast.appendChild(progress);

            setTimeout(() => this.closeToast(toast), duration);
        }

        container.appendChild(toast);
    };

    closeToast = (toast) => {
        toast.style.animation = "fadeOut 0.3s forwards";
        toast.addEventListener("animationend", () => toast.remove());
    };
}

customElements.define("toast-message", ToastMessage);
